<div class="container-small-card">
  <div>
    <img src="../../../../assets/icons/attchments.svg" alt="">
  </div>
  <p>Anexar 1</p>
</div>
